// This is just an example,
// so you can safely delete all default props below

export default {
    travel_from: 'Fra',
    travel_to: 'Til',
    stop_place_holder: 'Skriv inn eller velg et stopp/kai',
    outward_date: 'Utreise',
    backward_date: 'Retur',
    oneway: 'En vei',
    roundtrip: 'Tur/retur',
    search_trips: 'Søk og bestill',
    error_products_not_found: 'Det er ingen forbindelser mellom stedene du valgte, eller på datoen du valgte, eller det er ikke flere avganger i dag for valgt reise.',
    error_origin: 'Fra kai må velges',
    error_destination: 'Til kai må velges',
    error_outward_date: 'Utreise dato må velges',
    error_backward_date: 'Retur dato må velges',
    error_products: 'Ingen billettkategori er valgt',
    payment_option_desc: 'Valg av betalings- / reservasjons produkt velges på side 3'
}